import React from 'react'
import { Icon } from 'loyal-react'
import '@loyal_template/tracking.css'

const TrackingItem = props => (
  <ul className='tracking-steps col-12 px-0'>
    <li className='pos-relative'>
      <div className='row'>
        <div className='col-auto'>
          <Icon iconName='icon_check_circle' className='color-success' />
        </div>
        <div className='col-auto'>
          <p className='color-success txt-body'>
            <strong>Entregue</strong>
          </p>
          <p className='txt-subtitle pt-half'>em 10/10/2018 às 19:00</p>
        </div>
      </div>
    </li>
    <li className='pos-relative'>
      <div className='row'>
        <div className='col-auto'>
          <Icon iconName='icon_check_circle' className='color-success' />
        </div>
        <div className='col-auto'>
          <p className='color-success txt-body'>
            <strong>Em rota de entrega</strong>
          </p>
          <p className='txt-subtitle pt-half'>em 10/10/2018 às 19:00</p>
        </div>
      </div>
    </li>
    <li className='pos-relative'>
      <div className='row'>
        <div className='col-auto'>
          <Icon iconName='icon_check_circle' className='color-success' />
        </div>
        <div className='col-auto'>
          <p className='color-success txt-body'>
            <strong>Seu produto foi solicitado</strong>
          </p>
          <p className='txt-subtitle pt-half'>em 10/10/2018 às 19:00</p>
        </div>
      </div>
    </li>
  </ul>
)

export default TrackingItem



// WEBPACK FOOTER //
// ./src/features/User/Orders/TrackingItem.js